import { EvidenceStatus } from '../../models/chat.model';

// --- Fase 4: helpers de vista para el estado de evidencia (evidence_status) ---

/** Whitelist de estados de evidencia con etiqueta i18n propia; el resto cae en `unknown`. */
const KNOWN_EVIDENCE_STATUSES: ReadonlySet<string> = new Set<string>([
  'grounded', 'partially_grounded', 'no_evidence', 'validation_failed', 'retrieval_failed'
]);

/**
 * Estados que exigen advertir al usuario sobre la respuesta que está leyendo (P2-1).
 * Criterio: todo estado que `compute_evidence_status` produce y que significa que la
 * respuesta puede no ser confiable. `validation_failed` entra por el mismo criterio
 * (`evidence_status.py:26-42` lo devuelve con `validation_ok is False`): pinta chip rojo,
 * así que sin advertencia sería severidad sin la oración que la explique.
 * `grounded` no advierte, y un estado desconocido tampoco: fabricar una advertencia sin
 * saber sería el engaño en la dirección opuesta.
 */
const WARNING_EVIDENCE_STATUSES: ReadonlySet<string> = new Set<string>([
  'partially_grounded', 'no_evidence', 'validation_failed', 'retrieval_failed'
]);

/** Llave i18n para la etiqueta del estado de evidencia. `unknown` si no es conocido. */
export function evidenceStatusLabelKey(status: EvidenceStatus | null | undefined): string {
  const known = typeof status === 'string' && KNOWN_EVIDENCE_STATUSES.has(status);
  return `chat.grounding.evidence.${known ? status : 'unknown'}`;
}

/**
 * Llave i18n de la advertencia del estado de evidencia, o `null` si ese estado no
 * amerita advertir. El chip nombra el estado; esto explica qué significa para la
 * respuesta. NO reescribe la prosa del LLM: la acompaña.
 */
export function evidenceWarningKey(status: EvidenceStatus | null | undefined): string | null {
  if (typeof status !== 'string' || !WARNING_EVIDENCE_STATUSES.has(status)) {
    return null;
  }
  return `chat.grounding.evidence.warning.${status}`;
}
